import { useEffect } from "react";
import axios from "axios";
import { logout } from "../Redux Store/Slices/auth";
import store from "../Redux Store/store";
import { errorToast } from "./toasts";
import { useNavigate } from "react-router-dom";

// Your API endpoint for refreshing the token

const useAxiosInterceptor = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Request interceptor
    const requestInterceptor = axios.interceptors.request.use(
      async (config) => {
        // Check if access_token is available and not expired
        const accessToken = sessionStorage.getItem("access_token") || null;
        config.headers["Authorization"] = `Bearer ${accessToken}`;
        return config;
      },
      (error) => {
        console.log("Interceptor Error: ", error);
        errorToast("Token Expired, Please Login Again");
        store.dispatch(logout());
        navigate("/login");
        return Promise.reject(error);
      }
    );

    // Response interceptor
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.data.status === 401) {
          errorToast("Token Expired, Please Login Again");
          store.dispatch(logout());
          navigate("/login");
        }
        return Promise.reject(error);
      }
    );

    // Cleanup interceptors on unmount
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate]);
};

export default useAxiosInterceptor;
